import { useBreakpoint } from '@/shared/hooks/useBreakpoint';
import WorkersFiltersMobile from './WorkersFiltersMobile';
import WorkersFiltersDesktop from './WorkersFiltersDesktop';

export type WorkersFiltersProps = {
  values: any;
  onApply: (data: any) => void;
  onClear?: () => void;
  className?: string;
}

const WorkersFilters = (props: WorkersFiltersProps) => {
  const { isMinMediaSm } = useBreakpoint()
  return isMinMediaSm 
    ? <WorkersFiltersDesktop {...props}/> 
    : <WorkersFiltersMobile {...props}/>;
}

export default WorkersFilters;
